ScoreTrekBattle.PlayerSearch = (function() {
    var _this, uuid;

    uuid = 0;

    function renderClub(club) {
        let clubLogo, clubName, clubAddress;

        clubLogo = club ? (club.thumbnail || club.logo || ScoreTrekBattle.ASSETS.PLACEHOLDER.club) : ScoreTrekBattle.ASSETS.PLACEHOLDER.club;
        clubName = club ? __escapeHTML(club.official_name || '') : `<i>${__i18n('player/noClubAssigned')}</i>`;
        clubAddress = club ? `${club.zip || ''} ${club.city || ''}`.trim() : '';

        return [
            `<div class="player-club">`,
                `<span class="player-club-logo"${clubLogo ? ` style="background-image:url('${clubLogo}');"` : ''}></span>`,
                `<span class="player-club-text">`,
                    `<span class="player-club-name">${clubName}</span>`,
                    clubAddress ? `<span class="player-club-address">${__escapeHTML(clubAddress)}</span>` : '',
                `</span>`,
            `</div>`
        ].join('');
    }

    function renderPlayer(player) {
        let clubHtml;

        clubHtml = renderClub(player.club || null);

        return $([`<div class="p-medium player-item${player.pro_account ? ' isProPlayer' : ''}" data-item-type="searchResult" data-player-id="${player.id}" data-verified="${player.verified ? 'yes' : 'no'}">`,
            `<div class="player">`,
                `<span class="player-avatar" style="background-image:url('${player.thumbnail}');"></span>`,
                `<span class="player-name-wrapper">`,
                    `<span class="player-name row-center" data-id="playerName">`,
                        `${__escapeHTML(player.name)}`,
                    `</span>`,
                    clubHtml,
                `</span>`,
                `${!player.verified ? `<span class="row-center"><span class="badge bg-color-pink color-white ml-small" data-info-popup="player/info/notVerified"><i class="fa-solid fa-triangle-exclamation"></i></span></span>` : ''}`,
            `</div>`,
        `</div>`].join(''));
    }

    function renderClubPoolPlayer(leaguePlayer) {
        let app, thumbnail;

        app = leaguePlayer.player || {};
        thumbnail = app.thumbnail || '';

        return $([
            '<div class="p-medium player-item" data-item-type="poolResult">',
                '<div class="player">',
                    `<span class="player-avatar" style="background-image:url('${thumbnail}');"></span>`,
                    '<span class="player-name-wrapper">',
                        `<span class="player-name row-center">${__escapeHTML(leaguePlayer.fullName)}</span>`,
                    '</span>',
                    '<span class="row-center"><span class="badge bg-color-white color-pink ml-small" data-info-popup="squad/player/manualInfo"><i class="fa-solid fa-user-slash"></i></span></span>',
                '</div>',
            '</div>'
        ].join(''));
    }

    function clubPool(handlers) {
        handlers = handlers || {};

        return {
            provider: function() {
                return Api.request('/battle/league/players').then(result => {
                    return (result.list || []).filter(leaguePlayer => !leaguePlayer.playerId);
                });
            },
            getName: function(leaguePlayer) {
                return leaguePlayer.fullName || '';
            },
            render: renderClubPoolPlayer,
            isAdded: handlers.isAdded,
            onSelect: handlers.onSelect
        };
    }

    function openDialog(options) {
        var dialog, $searchInput, $searchResults, $searchResultsItems, $createSuggestion, $clubScope, $clubScopeToggle, poolItems, searches, clubScopeId;

        // options.title — overrides the dialog's own title, for consumers that
        // search players for a specific purpose (link a player, add a matchday
        // player) rather than just looking one up.
        // options.onSelect(player) — when provided, results are pickable and the
        // dialog stays open; already-added players (options.isAdded) are inert.
        // options.onCreate(name) — when provided, a "create «name»" row is shown
        // while typing so a free-text player can be added without an app account.
        // options.createLabel(name) builds that row's label; options.placeholder
        // overrides the search field's placeholder.
        // options.pool — an optional set of supplementary players merged into the
        // search results while searching (provider(), getName(item), render(item),
        // isAdded(item), onSelect(item)); e.g. a club's manually created players
        // that the app-player search cannot surface. Only consumers that pass this
        // option see them — the general and tournament searches never do.
        options = options || {};

        poolItems = [];

        searches = [];

        function cancelSearches() {
            searches.forEach(search => {
                search.cancel();
            });
        }

        function isSearching() {
            let isRunning = false;
            searches.forEach(search => {
                isRunning = isRunning || search.isRunning();
            });
            return isRunning;
        }

        function isOwnClubOnly() {
            return !!options.allowOtherClubs && !$clubScopeToggle.prop('checked');
        }

        function markAdded($row) {
            $row.addClass('isAdded');

            if ($row.find('[data-id="addedMark"]').length === 0) {
                $row.append('<span class="player-added-mark" data-id="addedMark"><i class="fa-solid fa-check"></i></span>');
            }
        }

        function clearSearch() {
            let hasValue;

            hasValue = $searchInput.val().length > 0;

            $searchInput.val('');

            cancelSearches();

            updateCreateSuggestion();

            if (!hasValue) {
                dialog.close();
                return;
            }

            if (isOwnClubOnly()) {
                startSearch();
            }
        }

        function startSearch() {
            let text, search, ownClubOnly;

            if (isSearching()) {
                setTimeout(startSearch, 500);
                return;
            }

            text = String($searchInput.val()).trim();
            ownClubOnly = isOwnClubOnly();

            if ((text.length < 2) && !ownClubOnly) {
                $searchResultsItems.empty();
                $searchResults.removeClass('loading');
                return;
            }

            $searchResults.addClass('loading');

            search = chmSearch('/battle/search/player');

            search.search(text, ownClubOnly ? {ownClubOnly: true} : null).then(result => {
                $searchResultsItems.empty();
                (result.players || []).forEach(player => {
                    let $player = renderPlayer(player);
                    if (options.onSelect) {
                        if (options.isAdded && options.isAdded(player.id)) {
                            markAdded($player);
                        }
                        $player.on('click', () => {
                            if ($player.hasClass('isAdded') || $player.hasClass('loading')) {
                                return;
                            }
                            $player.addClass('loading');
                            Promise.resolve(options.onSelect(player)).then(added => {
                                $player.removeClass('loading');
                                if (added !== false) {
                                    markAdded($player);
                                }
                            }).catch(() => {
                                $player.removeClass('loading');
                            });
                        });
                    } else {
                        $player.on('click', () => {
                            ScoreTrekBattle.Information.showParticipantInfo({
                                id: null,
                                playerId: player.id,
                                player: player
                            });
                        });
                    }
                    $searchResultsItems.append($player);
                });
                // Merge supplementary pool matches (e.g. manual club players)
                // after the app-player results.
                appendPoolMatches(text);
                $searchResults.removeClass('loading');
            }).catch(isCancelled => {
                if (!isCancelled) {
                    $searchResults.removeClass('loading');
                }
            });

            searches.push(search);
        }

        // ── Club player pool ──────────────────────────────────────
        // Supplementary players (options.pool) merged into the search results —
        // e.g. a club's manually created league players the app search cannot
        // surface. They are listed after the app-player results.

        function bindPick($row, isAdded, onSelect) {
            if (isAdded) {
                markAdded($row);
            }
            $row.on('click', () => {
                if ($row.hasClass('isAdded') || $row.hasClass('loading')) {
                    return;
                }
                $row.addClass('loading');
                Promise.resolve(onSelect()).then(added => {
                    $row.removeClass('loading');
                    if (added !== false) {
                        markAdded($row);
                    }
                }).catch(() => {
                    $row.removeClass('loading');
                });
            });
        }

        function poolName(item) {
            return String(options.pool && options.pool.getName ? options.pool.getName(item) : '');
        }

        function poolHasExactName(text) {
            var needle;
            if (!options.pool) {
                return false;
            }
            needle = text.trim().toLowerCase();
            return poolItems.some(item => poolName(item).toLowerCase() === needle);
        }

        // Append the pool players matching the current query to the result list.
        function appendPoolMatches(text) {
            var query, tokens, matches;

            if (!options.pool) {
                return;
            }

            query = String(text).trim().toLowerCase();

            if ((query.length < 2) && !isOwnClubOnly()) {
                return;
            }

            // Word-based AND matching mirrors the server search, so word order
            // and extra spaces don't matter ("müller klaus" finds "Klaus Müller").
            tokens = query.split(/\s+/).filter(Boolean);

            matches = poolItems.filter(item => {
                var name = poolName(item).toLowerCase();
                return tokens.every(token => name.indexOf(token) >= 0);
            });
            matches.sort((a, b) => poolName(a).localeCompare(poolName(b)));

            matches.forEach(item => {
                var $row = options.pool.render(item);
                bindPick($row, options.pool.isAdded ? options.pool.isAdded(item) : false, () => options.pool.onSelect(item));
                $searchResultsItems.append($row);
            });
        }

        function refreshAfterPool() {
            if ((String($searchInput.val()).trim().length >= 2) || isOwnClubOnly()) {
                startSearch();
            }
        }

        function loadPool() {
            if (!options.pool || !options.pool.provider) {
                refreshAfterPool();
                return;
            }

            Promise.resolve(options.pool.provider()).then(items => {
                poolItems = items || [];
            }).catch(() => {}).then(() => {
                // Re-run an already active search so its matches get merged in.
                refreshAfterPool();
            });
        }

        // ── Free-text player creation ─────────────────────────────
        // Renders a pickable "create «name»" row (options.onCreate) that stays
        // in sync with the search field, independent of the search results.

        function renderCreateRow(name) {
            var label;

            label = options.createLabel ? options.createLabel(name) : name;

            return $([
                '<div class="p-medium player-item player-item-create" data-item-type="createResult">',
                    '<div class="player">',
                        '<span class="player-avatar player-avatar-create"><i class="fa-solid fa-user-plus"></i></span>',
                        '<span class="player-name-wrapper ml-small">',
                            label,
                        '</span>',
                    '</div>',
                '</div>'
            ].join(''));
        }

        function runCreate(name, $row) {
            if ($row.hasClass('loading')) {
                return;
            }

            $row.addClass('loading');

            Promise.resolve(options.onCreate(name)).then(created => {
                $row.removeClass('loading');
                if (created !== false) {
                    // Reset the field so the next player can be entered at once.
                    $searchInput.val('');
                    $searchResultsItems.empty();
                    updateCreateSuggestion();
                    $searchInput.trigger('focus');
                    // Die eben angelegte Person gehoert ab jetzt zum Pool des
                    // Clubs — sonst liesse sie sich gleich noch einmal anlegen.
                    loadPool();
                }
            }).catch(() => {
                $row.removeClass('loading');
            });
        }

        function updateCreateSuggestion() {
            var text, $row;

            if (!options.onCreate) {
                return;
            }

            text = String($searchInput.val()).trim();

            $createSuggestion.empty();

            if (text.length < 2) {
                return;
            }

            // An existing pool player with that exact name is picked, not re-created.
            if (poolHasExactName(text)) {
                return;
            }

            $row = renderCreateRow(text);
            $row.on('click', function() {
                runCreate(text, $row);
            });

            $createSuggestion.append($row);
        }

        $searchInput = $('<input>').attr({
            'type': 'text',
            'placeholder': options.placeholder || __i18n('action/searchPlayer')
        }).addClass('player-search-input-text').on('input', function() {
            updateCreateSuggestion();
            startSearch();
        }).on('keydown', function(event) {
            if ([13, 27].indexOf(event.which) >= 0) {
                event.stopPropagation();
            }

            if (event.which === 27) {
                clearSearch();
            }
        });

        clubScopeId = `playerSearchClubScope_${uuid++}`;

        $clubScopeToggle = $('<input>').attr({
            'type': 'checkbox',
            'id': clubScopeId,
            'autocomplete': 'off'
        }).on('change', function() {
            cancelSearches();
            startSearch();
        });

        $clubScope = $('<div>').addClass('player-search-clubScope');

        if (options.allowOtherClubs) {
            $clubScope.append(
                $clubScopeToggle,
                $('<label>').attr('for', clubScopeId).append(
                    $('<i>').addClass('fa-solid fa-check'),
                    $('<span>').text(__i18n('player/search/otherClubs'))
                )
            );
        }

        $searchResults = $('<div>').addClass('player-search-results loader');
        $searchResultsItems = $('<div>').addClass('player-search-results-items');
        $createSuggestion = $('<div>').addClass('player-search-create');

        dialog = chmDialog({
            title: options.title || __i18n('dialog/playerSearch/title'),
            paddingTop: false,
            isPersistant: true,
            typeToFocus: $searchInput,
            content: $('<div>').append(
                $('<div>').addClass('row row-center row-between pb-medium').append(
                    $('<div>').addClass('player-search-input').append(
                        $searchInput,
                        $('<span>').addClass('player-search-input-icon').html('<i class="fa-solid fa-magnifying-glass"></i>')
                    ),
                    $('<span>').addClass('button button-transparent button-small').html('<i class="fa-solid fa-xmark"></i>').on('click', function() {
                        clearSearch();
                    })
                ),
                $clubScope,
                $createSuggestion,
                $searchResults.append($searchResultsItems)
            ),
            onShow: function() {
                if (options.autoFocus) {
                    $searchInput.trigger('focus');
                }

                loadPool();
            },
            afterClose: function() {
                cancelSearches();
            }
        });

        return dialog;
    }

    _this = {
        open: function(options) {
            return openDialog(options);
        },
        clubPool: clubPool
    };

    ScoreTrekBattle.Event.on('action.player.search', function(event) {
        if ($('[data-trigger-action="participant.add"]').length > 0) {
            ScoreTrekBattle.Event.trigger('action.participant.add', [{}, true]);
            return;
        }

        openDialog({autoFocus: true});
    });

    return _this;
})();
